import React from 'react';
import {
    FormattedDate,
    FormattedRelativeTime,
    FormattedTime,
} from 'react-intl';
import { intlDatetimeForCsv } from '../../utilities/general';

export function findGap(date){
    return (date ? (((new Date() - new Date(date)) / 1000) * -1):"");
}

export function DateTime(props){
    const {date, dateGap} = props;
    return (date ? (<React.Fragment>
                        <FormattedDate 
                        value={new Date(date)}
                        year="numeric"
                        month="long" 
                        day="2-digit"/>
                        <span className="margin-left-10"></span>
                        <FormattedTime value={new Date(date)} />
                        <br></br>
                        {dateGap ? (<FormattedRelativeTime
                        value={dateGap}
                        updateIntervalInSeconds={60}/>) : ""}
                  </React.Fragment>) : "");
}

export function csvDate(date, intl){
    //const intl = useIntl();
    return(date ? (intlDatetimeForCsv(new Date(date), intl)) : "NA");
}